'use client';

import {useEffect, useRef} from 'react';
import {usePathname} from 'next/navigation';

interface DataLayerEvent {
	event: string;
	page_location: string;
	page_title: string;
	page_referrer: string;
}

declare global {
	interface Window {
		dataLayer: DataLayerEvent[];
	}
}

export default function useRouteChange(): void {
	const pathname = usePathname();
	const prevLocationRef = useRef<string | null>(null);

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const currentUrl = window.location.href;
		const pageTitle = document.title;

		// Sjekk om vi allerede har logget denne siden
		if (prevLocationRef.current === currentUrl) return;

		// Første sidevisning: hent referrer fra storage eller document.referrer
		const fallbackReferrer = sessionStorage.getItem('last_page') || document.referrer || '';

		const referrer =
			prevLocationRef.current !== null ? prevLocationRef.current : fallbackReferrer;

		// Push til dataLayer
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'route_change',
			page_location: currentUrl,
			page_title: pageTitle,
			page_referrer: referrer,
		});

		// Oppdater både ref og sessionStorage
		prevLocationRef.current = currentUrl;
		sessionStorage.setItem('last_page', currentUrl);
	}, [pathname]);
}
